<template>
  <component :is="complaintView" />
</template>
<script>
import { mapGetters } from "vuex";
import CompanyComplaint from "@/views/pages/company/CompanyComplaint";
import CompanyComplaintAlternate from "@/views/pages/company/CompanyComplaintAlternate";
import CompanyComplaintCaixa from "@/views/pages/company/CompanyComplaintCaixa";
import CompanyComplaintJBJ from "@/views/pages/company/CompanyComplaintJBJ";
import CompanyComplaintMSDourada from "@/views/pages/company/CompanyComplaintMSDourada";

export default {
  name: "CompanyComplaintDelegate",
  computed: {
    ...mapGetters(["company", "portal"]),
    complaintView() {
      if (this.portal.slug === "caixavidaeprevidencia") {
        return CompanyComplaintCaixa;
      } else if (this.portal.slug === "jbjagropecuaria") {
        return CompanyComplaintJBJ;
      } else if (["msdourada", "aguapreta"].includes(this.portal.slug)) {
        return CompanyComplaintMSDourada;
      } else if (this.company.modules.complaint.alternateForm) {
        return CompanyComplaintAlternate;
      } else {
        return CompanyComplaint;
      }
    },
  },
};
</script>
